import { useTranslation } from '@/i18n/client';
import { Dialog, DialogActions, DialogContent, DialogContentText, Popover } from '@mui/material';
import to from 'await-to-js';
import cn from 'clsx';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import style from './index.module.scss';
// 组件
import CommonButton from '@/app/csr-src/pages/order/components/commonButton';
import DateSelect from '@/app/csr-src/pages/order/components/dateSelect';
import LocationModal from '@/app/csr-src/pages/order/components/locationModal';
import UKLoadingIcon, { CIRCLE_COLOR_MAP } from '@/components/UKLoadingIcon';
import UKToast from '@/components/UKToast/index';
import CDNImage from '@/components/cdnImage/cdnImage';
import ViewImage from '@/components/viewImage';
import AfsTrackModal from '../afsTrackModal';
// 接口
import {
  cancelAfsRecord,
  editReturnInfo,
  fetchCalendarList,
} from '@/apis/afterSales/afterSales.api';
import {
  AddressInfo,
  AfsServiceDetailVo,
  AfsServiceProcessNodeVo,
  CalendarData,
  ICancelRecordReq,
  NodeStatusListVo,
  PickUpDTO,
} from '@/apis/afterSales/afterSales.interface';
// utils
import { useFileSaver } from '@/utils/saveFile';
import { imageUtil } from '@/utils/imageUtil';

// 图标
import CompetedFilledIcon from '@/assets/icons/CompetedFilledIcon.svg';
import CompetedIcon from '@/assets/icons/CompetedIcon.svg';
import GradientLoadingIcon from '@/assets/icons/GradientLoadingIcon.svg';
import StepErrorIcon from '@/assets/icons/StepErrorIcon.svg';
import Expand from '@/assets/icons/chevron-down.svg';
interface statusAreaProps {
  afsDetailInfo: AfsServiceDetailVo;
  afsProcessNode: AfsServiceProcessNodeVo;
  onRefresh?: (cb?: any) => void;
}

const AfterSalesAccordion = ({ afsDetailInfo, afsProcessNode, onRefresh }: statusAreaProps) => {
  const { t } = useTranslation();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get('orderId') || ''; // 获取订单ID

  const {
    allowCancel, //是否显示取消售后按钮
    afsServiceId,
    applyDate,
    afsServiceStatus,
    returnModel,
    showWaybill,
    pickCustomerInfo,
    showReschedule,
    skuList,
  } = afsDetailInfo || {};
  const { nodeStatusList } = afsProcessNode || {};
  // 当前节点数据
  const curStepItem = nodeStatusList?.filter((item: any) => item.type === 2)?.[0] || {};

  // type 1为已完成，对号样式，2为当前状态，红底白字，3为未到达状态，白底黑字，4为已拒绝或者已取消状态，叉号样式
  const [progressList, setProgressList] = useState<any>([]);
  const [isEditPickUpTime, setIsEditPickUpTime] = useState<boolean>(false);
  const [curLocationInfo, setCurLocationInfo] = useState<any>(curStepItem?.stateDTO);
  const [againCancel, setAgainCancel] = useState(false); //是否展示二次确认弹窗
  const [showLocationModal, setShowLocationModal] = useState(false); // 展示驿站地图弹框
  const [isOpenReviewImage, setIsOpenReviewImage] = useState<boolean>(false);
  const curPickupTime = useRef(null);
  const [showTrackModal, setShowTrackModal] = useState(false);
  const { saveFile } = useFileSaver();

  const [isLoadingData, setIsLoadingData] = useState<boolean>(false);
  const [calendarList, setCalendarList] = useState<CalendarData[] | []>([]);
  const [showLoadingModal, setShowLoadingModal] = useState<boolean>(false);
  const [curItem, setCurItem] = useState<NodeStatusListVo | null>(null);

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const downPopoverOpen = Boolean(anchorEl);

  //保存修改的pickup时间
  const savePickUp = async (pickUpInfo: PickUpDTO) => {
    setShowLoadingModal(true);
    const requestData = {
      serviceId: afsServiceId,
      pickwareAddrFirstId: pickCustomerInfo?.addressInfo?.provinceId || '',
      pickwareAddrSecondId: pickCustomerInfo?.addressInfo?.cityId || '',
      pickwareAddrThirdId: pickCustomerInfo?.addressInfo?.countyId || '',
      pickwareAddrFourthId: pickCustomerInfo?.addressInfo?.townId || '',
      pickupAddrId: pickCustomerInfo?.addressInfo?.addressId || '',
      pickwareAddr: pickCustomerInfo?.addressInfo?.pickUpAddress || '',
      reserveDateBegin: (curPickupTime.current as any)?.startTime, // 修改上门取件时间需要传
      reserveDateEnd: (curPickupTime.current as any)?.endTime, // 修改上门取件时间需要传
      reserveDate: (curPickupTime.current as any)?.promiseDate, // 修改上门取件时间需要传
      batchId: (curPickupTime.current as any)?.batchId, // 修改上门取件时间需要传
      productType: (curPickupTime.current as any)?.productType, // 修改上门取件时间需要传
      // postHouseId: string, // 修改驿站需要传
      // stationName: string, // 修改驿站需要传
      pickUpStationAddressInfo: {
        ...pickUpInfo,
      },
    };
    const [err, editReturnInfoData] = await to(editReturnInfo(requestData));
    setShowLoadingModal(false);
    if (err) {
      UKToast.show({
        content: t('afterSales.afterSalesAccordion.rescheduleFailTip'), // 弹窗内容
        icon: 'warning', // 可选：success, fail, loading, warn, info，影响图标
        duration: 2000, // 不写的话默认3000
      });
    } else {
      if (parseFloat(editReturnInfoData?.code) === 200 && editReturnInfoData?.success) {
        UKToast.show({
          content: t('afterSales.afterSalesAccordion.rescheduleSuccTip'), // 弹窗内容
          icon: 'success', // 可选：success, fail, loading, warn, info，影响图标
          duration: 2000, // 不写的话默认3000
        });
        setTimeout(() => {
          onRefresh &&
            onRefresh(() => {
              setIsEditPickUpTime(false);
            });
        }, 2000);
      } else {
        UKToast.show({
          content: t('afterSales.afterSalesAccordion.rescheduleFailTip'), // 弹窗内容
          icon: 'warning', // 可选：success, fail, loading, warn, info，影响图标
          duration: 2000, // 不写的话默认3000
        });
      }
    }
  };

  // 取消售后
  const cancelRequestHandler = async () => {
    setAgainCancel(false);
    const requestData: ICancelRecordReq = { afsServiceId };
    const [err, cancelAfsRecordData] = await to(cancelAfsRecord(requestData));

    if (err) {
      UKToast.show({
        content: t('afterSales.statusArea.cancelFailTips'), // 弹窗内容
        icon: 'warning', // 可选：success, fail, loading, warn, info，影响图标
        duration: 2000, // 不写的话默认3000
      });
    } else {
      if (parseFloat(cancelAfsRecordData?.code) === 200 && cancelAfsRecordData?.success) {
        UKToast.show({
          content: t('afterSales.statusArea.cancelSuccessTips'), // 弹窗内容
          icon: 'success', // 可选：success, fail, loading, warn, info，影响图标
          duration: 2000, // 不写的话默认3000
        });
        setTimeout(() => {
          onRefresh && onRefresh();
        }, 2000);
      } else {
        UKToast.show({
          content: t('afterSales.statusArea.cancelFailTips'), // 弹窗内容
          icon: 'warning', // 可选：success, fail, loading, warn, info，影响图标
          duration: 2000, // 不写的话默认3000
        });
      }
    }
  };

  //下载二维码
  const downloadHandler = (url: string, type: string) => {
    url && saveFile(url, type);
  };

  // 打印面单
  const handlePrint = (imageUrl: string) => {
    const printWindow = window.open('', '_blank');
    printWindow?.document?.write(`
      <html>
        <head>
          <title>图片打印</title>
          <style>
            body { 
              margin: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
              background-color: white;
            }
            img {
              max-width: 100%;
              max-height: 100vh;
              object-fit: contain;
            }
          </style>
        </head>
        <body>
          <img src="${imageUrl}" alt="打印图片" onload="window.print()" />
        </body>
      </html>
    `);
    printWindow?.document?.close();
  };

  // 选择驿站回调
  const locationChangeHandler = async (val: any) => {
    // 改变驿站信息
    if (val) {
      const requestData = {
        serviceId: afsServiceId,
        pickwareAddrFirstId: val?.provinceId || '',
        pickwareAddrSecondId: val?.cityId || '',
        pickwareAddrThirdId: val?.countyId || '',
        pickwareAddrFourthId: val?.townId || '',
        pickupAddrId: '-1', // 暂定-1
        pickwareAddr: val?.fullAddressDetail || '',
        postHouseId: val?.postHouseId, // 修改驿站需要传
        stationName: val?.postHouseName, // 修改驿站需要传
        pickUpStationAddressInfo: {
          ...val,
        },
      };
      const [err, editReturnInfoData] = await to(editReturnInfo(requestData));
      if (err) {
        UKToast.show({
          content: t('afterSales.afterSalesAccordion.changeFailTip'), // 弹窗内容
          icon: 'warning', // 可选：success, fail, loading, warn, info，影响图标
          duration: 2000, // 不写的话默认3000
        });
      } else {
        if (parseFloat(editReturnInfoData?.code) === 200 && editReturnInfoData?.success) {
          setShowLocationModal(false);
          UKToast.show({
            content: t('afterSales.afterSalesAccordion.changeSuccTip'), // 弹窗内容
            icon: 'success', // 可选：success, fail, loading, warn, info，影响图标
            duration: 2000, // 不写的话默认3000
          });
          setCurLocationInfo(val);
        } else {
          UKToast.show({
            content: t('afterSales.afterSalesAccordion.changeFailTip'), // 弹窗内容
            icon: 'warning', // 可选：success, fail, loading, warn, info，影响图标
            duration: 2000, // 不写的话默认3000
          });
        }
      }
    }
  };
  useEffect(() => {
    const reversedArr = [...nodeStatusList.filter((x) => x.type !== 3)].reverse() || [];
    setProgressList(reversedArr);
  }, [nodeStatusList]);

  const timeChangeHandler = (val: any) => {
    curPickupTime.current = val;
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const formatWareList =
    skuList?.map(
      ({
        skuId,
        skuUUid,
        appliedCount,
      }: {
        skuId: number;
        skuUUid: string;
        appliedCount?: number;
      }) => ({
        skuId,
        skuUUid,
        applyCount: appliedCount,
      }),
    ) || [];

  // 请求日历接口
  const loadCalendarList = async () => {
    setIsLoadingData(true);
    const requestData = {
      orderId: orderId,
      pickwareAddrFirstId: pickCustomerInfo?.addressInfo?.provinceId,
      pickwareAddrSecondId: pickCustomerInfo?.addressInfo?.cityId,
      pickwareAddrThirdId: pickCustomerInfo?.addressInfo?.countyId,
      pickwareAddrFourthId: pickCustomerInfo?.addressInfo?.townId,
      pickwareAddr: pickCustomerInfo?.addressInfo?.fullAddressDetail,
      afsServiceId,
      afsSkuQueries: formatWareList,
    };
    const [err, calendarDataRes] = await to(fetchCalendarList(requestData));

    if (err) {
      // setError("Failed to fetch address list");
      setCalendarList([]);
    } else {
      if (calendarDataRes?.length) {
        setCalendarList(calendarDataRes as CalendarData[]);
      } else {
        // 接口返回失败的时候，列表为空，不展示任何时间段
        setCalendarList([]);
      }
      // setError(null);
    }
    setIsLoadingData(false);
    setIsEditPickUpTime(true);
  };

  const getParamsMap = (addressInfo: AddressInfo) => {
    return {
      postCode: addressInfo?.postCode || '',
      firstAddressId: addressInfo?.provinceId,
      firstAddressName: addressInfo?.provinceName,
      secondAddressId: addressInfo?.cityId,
      secondAddressName: addressInfo?.cityName,
      thirdAddressId: addressInfo?.countyId,
      fourthAddressId: addressInfo?.townId,
      addressDetail: addressInfo?.addressDetail,
      houseNumber: addressInfo?.houseNumber,
      orderId,
    };
  };

  // item.type
  // 1-走过的节点状态 展示红色对钩
  // 2-当前节点状态  展示红色数字
  // 3-未到达的节点状态 展示白色数字
  // 4-中断类型（拒绝、驳回、取消节点使用 优先级最高）展示红叉

  if (progressList.length > 0) {
    return (
      <div className={style.afterSalesTrajectory_wrap}>
        {progressList.map((item: any, index: number) => {
          return (
            <div className={style.trajectoryItem} key={item.order}>
              <div className={style.title}>
                <div className={`${style.titleText} ${index === 0 ? style.expanded : ''}`}>
                  {item.type === 1 ? (
                    index === 0 ? ( // 第一个为红底样式
                      <CompetedFilledIcon
                        className={style.competedIcon}
                        color='#CC0C1C'
                        width={18}
                        height={18}
                      />
                    ) : (
                      <CompetedIcon
                        className={style.competedIcon}
                        color='#CC0C1C'
                        width={18}
                        height={18}
                      />
                    )
                  ) : item.type === 4 ? (
                    <StepErrorIcon
                      className={style.competedIcon}
                      color='#CC0C1C'
                      width={18}
                      height={18}
                    />
                  ) : (
                    <div className={style.activeIcon}>{item.order}</div>
                  )}
                  <span>{item.subText}</span>
                </div>
                {/* 右侧操作按钮 */}
                <div className={style.btnWrap}>
                  {allowCancel && index === 0 && (
                    <CommonButton variant='outlined' onClick={() => setAgainCancel(true)}>
                      {t('afterSales.afterSalesAccordion.withdraw')}
                    </CommonButton>
                  )}
                  {showWaybill && index === 0 && (
                    <CommonButton variant='outlined' onClick={() => setShowTrackModal(true)}>
                      {t('afterSales.afterSalesAccordion.track')}
                    </CommonButton>
                  )}
                  {item?.returnLabelUrl && index === 0 && (
                    <CommonButton
                      variant='outlined'
                      onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                        setCurItem(item);
                        setAnchorEl(event.currentTarget);
                      }}
                      style={{ marginLeft: '12px' }}
                    >
                      {t('afterSales.afterSalesAccordion.returnLabel')}
                    </CommonButton>
                  )}
                </div>
                {/* 有按钮的时候不展示时间 */}
                {!((allowCancel || showWaybill || item?.returnLabelUrl) && index === 0) &&
                  item.stepTime && <div className={style.date}>{item.stepTime}</div>}
              </div>
              {item.desc && <div className={style.content}>{item.desc}</div>}
              {item.type === 2 ? (
                <>
                  {/* 节点return会有以下两种场景drop-off和pick-up */}
                  {returnModel === 70 ? (
                    <>
                      {item.qrcode || curLocationInfo ? (
                        <div className={style.returnDropOff}>
                          {curLocationInfo ? (
                            <div className={style.left}>
                              <div className={style.leftTitle}>
                                <span>{curLocationInfo.postHouseName}</span>
                                {/* <span style={{ display: "inline-block", marginLeft: "16px" }}>{curLocationInfo.distance}mi</span> */}
                                {item.showPosthouseBtn && (
                                  <span
                                    className={style.changeBtn}
                                    onClick={() => {
                                      setShowLocationModal(true);
                                    }}
                                  >
                                    {t('afterSales.afterSalesAccordion.changeBtn')}
                                    <Expand className={style.entryIco} />
                                  </span>
                                )}
                              </div>
                              <div className={style.leftAdd}>
                                {curLocationInfo.fullAddressDetail}
                              </div>
                              {!!curLocationInfo.businessHours.length && (
                                <ul className={style.openingTime}>
                                  <li className={style.openingTimeLi}>
                                    {t('afterSales.afterSalesAccordion.openingTime')}
                                  </li>
                                  {curLocationInfo.businessHours &&
                                    curLocationInfo.businessHours.length > 0 &&
                                    curLocationInfo.businessHours.map((x: any) => {
                                      return (
                                        <li className={style.openingTimeLi} key={x.sortIndex}>
                                          <span>{x.title}</span>
                                          <span>{x.subTitle}</span>
                                        </li>
                                      );
                                    })}
                                </ul>
                              )}
                            </div>
                          ) : null}
                          {item.qrcode ? (
                            <div className={style.right}>
                              <div
                                className={style.qrImage}
                                onClick={() => {
                                  setIsOpenReviewImage(true);
                                }}
                              >
                                <CDNImage width={160} height={160} src={item.qrcode} />{' '}
                              </div>

                              <div className={style.qrTips}>
                                <span className={style.qrText}>{item.qrCodeText}</span>
                                <div
                                  className={style.qrDownload}
                                  onClick={() => downloadHandler(item.qrcode || '', 'image')}
                                >
                                  {t('afterSales.afterSalesAccordion.downloadQrCode')}
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                    </>
                  ) : item?.pickUpDTO ? (
                    <>
                      <div className={style.returnPickUp}>
                        <div className={style.pickUpTime}>
                          <div className={style.pickUpTimeTitle}>
                            {t('afterSales.afterSalesAccordion.pickUpTime')}
                          </div>
                          {/* 优先展示上门取件异常场景, 其次展示时间 */}
                          {item?.pickUpDTO?.timePassed || item?.pickUpMessage ? (
                            <div className={style.pickUpTimeContent}>
                              <div className={style.pickUpFailText}>
                                {item?.pickUpDTO?.timePassed || item?.pickUpMessage}
                              </div>
                            </div>
                          ) : isLoadingData ? (
                            <div
                              className={cn(
                                style.pickUpTimeContent,
                                style.pickUpTimeLoadingContent,
                              )}
                            >
                              <UKLoadingIcon
                                type={CIRCLE_COLOR_MAP.BLACK}
                                className={style.loadingIcon}
                              />
                              {t('afterSales.afterSalesAccordion.loadingText')}
                            </div>
                          ) : (
                            <div className={style.pickUpTimeContent}>
                              {isEditPickUpTime ? (
                                <div className={style.dateBox}>
                                  <DateSelect
                                    requestData={{
                                      orderId: orderId,
                                      pickwareAddrFirstId:
                                        pickCustomerInfo?.addressInfo?.provinceId,
                                      pickwareAddrSecondId: pickCustomerInfo?.addressInfo?.cityId,
                                      pickwareAddrThirdId: pickCustomerInfo?.addressInfo?.countyId,
                                      pickwareAddrFourthId: pickCustomerInfo?.addressInfo?.townId,
                                      pickwareAddr:
                                        pickCustomerInfo?.addressInfo?.fullAddressDetail,
                                      afsServiceId,
                                      afsSkuQueries: formatWareList,
                                    }}
                                    selectedInfo={{
                                      date: item?.pickUpDTO?.date,
                                      time: item?.pickUpDTO?.time,
                                    }}
                                    position='bottom'
                                    selectChangeHandler={timeChangeHandler}
                                    defaultList={calendarList}
                                  />
                                </div>
                              ) : item?.pickUpDTO?.date ? (
                                <div className={style.pickUpTimeContentText}>
                                  {item?.pickUpDTO?.date}
                                  {item?.pickUpDTO?.time ? `, ${item?.pickUpDTO?.time}` : ''}
                                </div>
                              ) : null}
                              {isEditPickUpTime || showReschedule ? (
                                <div className={style.pickUpTimeContentBtns}>
                                  {isEditPickUpTime ? (
                                    <>
                                      <div
                                        className={`${style.pickUpTimeContentBtn}`}
                                        onClick={() => setIsEditPickUpTime(false)}
                                      >
                                        {t('order.orderList.common.cancelBtnText')}
                                      </div>
                                      <div
                                        className={`${style.pickUpTimeContentBtn} ${style.save}`}
                                        onClick={() => {
                                          if (!showLoadingModal) {
                                            savePickUp(item?.pickUpDTO);
                                          }
                                        }}
                                      >
                                        {t('order.orderList.common.saveBtnText')}
                                      </div>
                                    </>
                                  ) : showReschedule ? (
                                    <div
                                      className={`${style.pickUpTimeContentBtn}`}
                                      onClick={() => loadCalendarList()}
                                    >
                                      {t('afterSales.afterSalesAccordion.reschedule')}
                                    </div>
                                  ) : null}
                                </div>
                              ) : null}
                            </div>
                          )}
                        </div>
                        <div className={style.pickUpAddress}>
                          <div className={style.pickUpAddressTitle}>
                            {t('order.orderDetail.returnRequestModal.pickUpText')}
                          </div>
                          <div className={style.pickUpAddressContent}>
                            <p className={style.address}>
                              <span className={style.addressName}>{item?.pickUpDTO?.customer}</span>
                              {item?.pickUpDTO?.phone ? (
                                <span className={style.phone}>
                                  {item?.pickUpDTO?.phone?.indexOf('+') > -1
                                    ? item?.pickUpDTO?.phone
                                    : `+${item?.pickUpDTO?.phone}`}
                                </span>
                              ) : null}
                            </p>
                            <p className={style.addressDetails}>
                              {item?.pickUpDTO?.fullAddressDetail}
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                </>
              ) : null}
            </div>
          );
        })}

        {/* 取消二次确认弹窗 */}
        <Dialog
          open={againCancel}
          onClose={() => setAgainCancel(false)}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {t('afterSales.statusArea.cancelModal.cancelConfirmText')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <CommonButton variant='outlined' onClick={() => setAgainCancel(false)}>
              {t('afterSales.statusArea.cancelModal.cancelBtnText')}
            </CommonButton>
            <CommonButton variant='contained' onClick={cancelRequestHandler} sx={{ boxShadow: 'none' }}>
              {t('afterSales.statusArea.cancelModal.confirmBtnText')}
            </CommonButton>
          </DialogActions>
        </Dialog>
        {/* 驿站弹框 */}
        {showLocationModal && (
          <LocationModal
            isOpen={showLocationModal}
            selectValue={curLocationInfo?.postHouseId}
            selectChangeHandler={locationChangeHandler}
            closeHandler={() => {
              setShowLocationModal(false);
            }}
            selectPostCode={curLocationInfo?.postCode || ''}
            initParams={getParamsMap(curLocationInfo)}
            orderId={orderId}
          />
        )}
        {/* 预览大图弹框 */}
        <ViewImage
          open={isOpenReviewImage}
          imageUrl={curStepItem?.qrcode}
          urlList={[curStepItem?.qrcode]}
          closeView={() => setIsOpenReviewImage(false)}
        />
        {/* 物流轨迹弹框 */}
        {showTrackModal && (
          <AfsTrackModal isOpen={showTrackModal} closeHandler={() => setShowTrackModal(false)} />
        )}
        {/* 加载提示框 */}
        {showLoadingModal && (
          <Dialog
            open={showLoadingModal}
            // onClose={() => setShowLoadingModal(false)}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
            sx={{
              '& .MuiDialog-paper': {
                borderRadius: '8px',
                minWidth: 'auto',
              },
            }}
          >
            <div className={style.loadingModalWrap}>
              <GradientLoadingIcon className={style.submitLoadingIco} />
              {t('afterSales.afterSalesAccordion.submitLoadingText')}
            </div>
          </Dialog>
        )}
        {/* 面单按钮点击选择框 */}
        {downPopoverOpen && (
          <Popover
            open={downPopoverOpen}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            slotProps={{
              paper: {
                sx: {
                  boxShadow: '0px 4px 28px 0px rgba(0, 0, 0, 0.08)', // 自定义阴影
                },
              },
            }}
          >
            <div className={style.invoiceDownloadWrap}>
              <div
                className={style.invoiceDownloadItem}
                onClick={() => {
                  handleClose();
                  const url = imageUtil.concatImgUrlWithoutForceHttps(
                    curItem?.returnLabelUrl || '',
                  );
                  window.open(url);
                }}
              >
                {t('afterSales.afterSalesAccordion.viewBtn')}
              </div>
              <div
                className={style.invoiceDownloadItem}
                onClick={() => {
                  handleClose();
                  const url = imageUtil.concatImgUrlWithoutForceHttps(
                    curItem?.returnLabelUrl || '',
                  );
                  downloadHandler(url, 'image');
                }}
              >
                {t('afterSales.afterSalesAccordion.downloadBtn')}
              </div>
              <div
                className={style.invoiceDownloadItem}
                onClick={() => {
                  handleClose();
                  const url = imageUtil.concatImgUrlWithoutForceHttps(
                    curItem?.returnLabelUrl || '',
                  );
                  handlePrint(url);
                }}
              >
                {t('afterSales.afterSalesAccordion.printBtn')}
              </div>
            </div>
          </Popover>
        )}
      </div>
    );
  }
};

export default AfterSalesAccordion;
